/**
 * Public privacy policy (`/privacy`).
 *
 * DRAFT pending legal review — see `src/content/legal.ts` for what is grounded
 * in the system's own record and what is still awaiting an owner's answer.
 *
 * Google requires a reachable Privacy Policy URI on a verified domain before an
 * External OAuth app can be published, so this route is public, unauthenticated,
 * and fetches nothing: it renders from static content plus the tenant identity
 * `useTenantPresentation()` already resolves from the request host.
 */
import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { LEGAL_ROUTES, legalTenantFacts, privacyPolicyDocument } from "@/content/legal";
import { useTenantPresentation } from "@/hooks/use-tenant-presentation";

export function PrivacyPolicyPage() {
  const { name, logoUrl, parentOrg, content } = useTenantPresentation();

  return (
    <LegalDocumentPage
      brandName={name}
      logoUrl={logoUrl}
      parentOrg={parentOrg}
      content={privacyPolicyDocument(legalTenantFacts(name, content))}
      sibling={{ label: "Terms of service", to: LEGAL_ROUTES.terms }}
    />
  );
}
